import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {RatingService} from "./rating.service";
import {AppService} from "../../../core/services/app.service";
import { UserService } from "../../user/services/user.service";
import { UserStatusConstant } from "../../../shared/constants/user-status-constant";

@Injectable({
    providedIn: 'root'
})

export class UserComments {

    comment = AppService.getApiUrl() + '/api/comments';

    constructor(private http: HttpClient, private ratingService: RatingService, private userService: UserService) {
    }

    sendMessage(photoComments, ownerPhoto, userId, ratingData, group = null) {
        let isReply = false;
        const tempArr = [];
        // Get owner photo info.
        if (ownerPhoto && ownerPhoto.id != userId && ownerPhoto.status != UserStatusConstant.DELETED) {
            tempArr.push({
                id: ownerPhoto.id,
                email: ownerPhoto.email,
                isOwner : true,
            });
        }

        // Get ratingData
        if (photoComments === null) {
            this.ratingService.getRatingByPhoto(ratingData.photoId).toPromise().then((res) => {
                photoComments = res['Data'];
            })
        }

        // Get comment and reply in photo
        if (photoComments && photoComments.length > 0) {
            photoComments.forEach((replyComment) => {
                if (replyComment.general_text) {
                    if (replyComment.customer['id'] != userId && replyComment.customer['id'] && replyComment.customer['email'] && replyComment.customer.status != UserStatusConstant.DELETED) {
                        tempArr.push({
                            id: replyComment.customer['id'],
                            email: replyComment.customer['email'],
                        });
                    }

                    if (replyComment.replyComments && replyComment.replyComments.length > 0) {
                        replyComment.replyComments.forEach((item) => {
                            if (item.customerId != userId && item.customer.status != UserStatusConstant.DELETED) {
                                tempArr.push({
                                    id: item.customerId,
                                    email: item.customer['email'],
                                });
                            }
                        });
                    }
                }
            });
            isReply= true;
        }

        // Unique data array object
        let params: any = {
            customerId: userId,
            group: group,
            isReply: isReply,
            ratingData: {
                content: ratingData.content,
                photoId: ratingData.photoId,
                modelId: ratingData.modelId
            },
            userComments: tempArr.reduce(
                (x,y) => x.findIndex( e => e.id === y.id ) < 0 ? [...x, y] : x, []
            )
        };
    
        this.http.post(this.comment + '/sendMessage', params).subscribe();
    }
}
